import React from "react";
import "../../css/Checkout.css";

const CheckoutCart = ({ cartItems }) => {
  const totalAmount = cartItems
    .reduce((sum, item) => sum + (item.price || 0) * (item.quantity || 0), 0)
    .toFixed(2);

  return (
    <div className="checkout-summary">
      <h3>Order Summary</h3>
      {cartItems.map((item) => (
        <div key={item.id} className="checkout-summary-row">
          <span>
            {item.name} x{item.quantity}
          </span>
          <span>${(item.price * item.quantity).toFixed(2)}</span>
        </div>
      ))}
      <div className="checkout-total">
        <span>Total:</span>
        <span>${totalAmount}</span>
      </div>
    </div>
  );
};

export default CheckoutCart;
